module.exports = __webpack_public_path__ + "static/img/shipinhuiyi2.44da5ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/shipinhuiyi2.png
// module id = hN3E
// module chunks = 24